import { TableColumProps } from "@/components/molecules/Table";
import { fakeI18n } from "@/i18n";
import { InvoiceSortProperty } from "@/shared/domain";

export const invoiceTableColumns: TableColumProps<MyBrokerApi.Invoice, InvoiceSortProperty>[] = [
    {
        sortableKey: "reference",
        label: fakeI18n.t("Common.Reference"),
        width: 19,
    },
    {
        sortableKey: "branch.name",
        label: fakeI18n.t("Common.Concerns"),
        width: 27,
    },
    {
        sortableKey: "amount",
        label: fakeI18n.t("Common.Amount"),
        width: 18,
    },
    {
        sortableKey: "date",
        label: fakeI18n.t("Common.DueDateShort"),
        width: 18,
    },
    {
        sortableKey: "status.id",
        label: fakeI18n.t("Common.Status"),
        width: 18,
    },
];
